import React, { useState, useEffect, useRef } from 'react';
import 'jqwidgets-framework/jqwidgets/jqxcore';
import 'jqwidgets-framework/jqwidgets/jqxdata';
import 'jqwidgets-framework/jqwidgets/jqxbuttons';
import 'jqwidgets-framework/jqwidgets/jqxscrollbar';
import 'jqwidgets-framework/jqwidgets/jqxmenu';
import 'jqwidgets-framework/jqwidgets/jqxgrid';
import 'jqwidgets-framework/jqwidgets/jqxgrid.pager';
import 'jqwidgets-framework/jqwidgets/jqxgrid.sort';
import 'jqwidgets-framework/jqwidgets/jqxgrid.edit';
import 'jqwidgets-framework/jqwidgets/jqxgrid.filter';
import 'jqwidgets-framework/jqwidgets/jqxgrid.selection';
import 'jqwidgets-framework/jqwidgets/jqxgrid.columnsresize';
import 'jqwidgets-framework/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-framework/jqwidgets/styles/jqx.dark.css';
import $ from 'jqwidgets-framework/jqwidgets/jqx-all';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs, Button, Modal, Form, Badge } from 'react-bootstrap';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
// import Slider from "react-slick";
import { Link } from 'react-router-dom';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';

// import { MultiSelect } from 'react-multi-select-component';
import Dropdown from 'react-bootstrap/Dropdown';
import Docmnt from '../../../assets/images/google-docs.png';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import Export from "../../../assets/images/export.svg";
import edit from "../../../assets/images/edit.png";
import Trash from '../../../assets/images/trash.png';
import Cargoplane from "../../../assets/images/plane.svg";
// import Cuser from "../../../assets/images/cuser.png";
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ImageUpload from '../../../Components/common/ImageUpload';
import ActivityComments from '../../../Components/common/ActivityComments';
import EditUld from './components/EditUld.js';
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { toast } from 'react-toastify';
// import useDropdownActions from '../../../Components/common/useDropdownActions.js';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDASSETSGRID, GETDAMAGETYPE, UPDATESTATUS, UPDATECONDITION, GETULDDETAILS, MOVETOACTARC, DOWNLOADULD, GETTYPECODE, GETDESTINATION, GETCONDITIONCODE, GETOWNERCODE, MVTHDETAILS, RECMISSING } from '../../../Utils/conts.js';
import Loader from '../../../Components/common/Loader.js';
import DownloadGrid from './components/DownloadGrid.js';
import { forEach } from 'lodash';
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js'; 
import XLSFILE from '../../../assets/ULD_Equipment_Expiry_Date.xls'; 

const Assets = () => {

    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        // Trash: []

    });
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const isMounted = useRef(false);
    const [damageType, setDamageType] = useState([]);
    const [totalRows, setTotalRows] = useState({});
    const [totalRowsR, setTotalRowsR] = useState(0);
    const [filterApplied, setFilterApplied] = useState(false);
    const [inactiveCount, setInactiveCount] = useState(0);
    const [missingDateTime, setMissingDateTime] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [fileName, setFileName] = useState('');
    const handleModalClose = () => { setShowModal(false); setFileName(''); };

    const fetchDataGrid = async (pageNumber, psize) => {
        const page_number = pageNumber ? pageNumber : 1;
        const pageSize = psize ? psize : 20;
        setIsLoading(true);
        const tabName = activeTab == 'Active' ? 'A' : 'R';
        try {
            const res = await withRFSToken.post(ULDASSETSGRID, { page: page_number, type: tabName, page_size: pageSize })
            // .then(function (res) {
            if (res.data.response_code == 200) {
                setIsLoading(false);
                const innerData = res.data.response_data.ulds;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData({ Active: innerData });
                setTotalRows({
                    pageSize: res.data.response_data.page_size,
                    currPage: res.data.response_data.current_page,
                    lastPage: res.data.response_data.last_page,
                    totalUlds: res.data.response_data.total_ulds
                });
                setTotalRowsR({
                    totalUlds: res.data.response_data.archive_count
                });
                // window.$(gridRefs[activeTab].current).jqxGrid('pagesize', res.data.response_data.page_size);
            }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };
    const fetchDataGridR = async (pageNumber, psize) => {
        const page_number = pageNumber ? pageNumber : 1;
        const pageSize = psize ? psize : 20;
        setIsLoading(true);
        try {
            const res = await withRFSToken.post(ULDASSETSGRID, { page: page_number, type: 'R', page_size: pageSize });
            setIsLoading(false);
            // .then(function (res) {
            if (res.data.response_code == 200) {
                const innerData = res.data.response_data.ulds;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData({ Archived: innerData });
                setTotalRowsR({
                    pageSize: res.data.response_data.page_size,
                    currPage: res.data.response_data.current_page,
                    lastPage: res.data.response_data.last_page,
                    totalUlds: res.data.response_data.total_ulds
                });
                // });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };
    const fetchDataInactive = async () => {

        try {
            const res = await withRFSToken.get('inactive/uld-list')
                .then(function (res) {
                    setInactiveCount(res?.data.TotalRows || 0);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData({ Active: {} });
        fetchDataInactive();
        // fetchDataGridR();
        isMounted.current = true;
    }, []);
    const fetchDamageType = async () => {
        try {
            const res = await withRFSToken.post(GETDAMAGETYPE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setDamageType(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [missingData, setMissingData] = useState(null);
    const [selectedRowDetails, setSelectedRowDetails] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [activeTab, setActiveTab] = useState('Active');

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
        // let tabType = '';
        // if (tab == 'Active') { tabType = 'A' } else { tabType = 'R' }
        // if (tab == 'Active') { fetchDataGrid() } else { fetchDataGridR() }
        // setIsLoading(true);
        // try {
        //     const res = await withRFSToken.post(ULDASSETSGRID, { type: tabType });
        //     setIsLoading(false);
        //     // .then(function (res) {
        //     if (res.data.response_code == 200) {
        //         const innerData = res.data.response_data.ulds;
        //         // console.log("🚀 ~ .then ~ innerData:654", innerData)
        //         // const transformData = innerData ? innerData.map(data => ({...data, reg: 'R' })) : '';
        //         if (tabType == 'A') {
        //             // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
        //             setGridData({ Active: innerData });
        //             // setTotalRows(res.data.response_data.total_ulds);
        //             setTotalRows({
        //                 pageSize: res.data.response_data.page_size,
        //                 currPage: res.data.response_data.current_page,
        //                 lastPage: res.data.response_data.last_page,
        //                 totalUlds: res.data.response_data.total_ulds
        //             });
        //         } else {
        //             // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'N' })) : '';
        //             setGridData({ Archived: innerData });
        //             setTotalRowsR(res.data.response_data.total_ulds);
        //         }
        //         // });
        //     }
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    };
    const [cellEdit, setCellEdit] = useState(false);
    const [cellEditData, setCellEditData] = useState({});
    // Edit Uld
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});
    const [missingCount, setMissingCount] = useState(0);

    const handleCloseEditModal = () => {
        setShowEdit(false);
        setEditData({});
    };

    // const gridSelectRef = useRef(gridSelect); // Create a ref for gridSelect

    // useEffect(() => {
    //     gridSelectRef.current = gridSelect; // Update the ref with the latest gridSelect value
    // }, [gridSelect]);
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall()
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'condition', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'scm', type: 'string' },
                    { name: 'scm_date', type: 'date' },
                    { name: 'asset_type', type: 'string' },
                    { name: 'handler_name', type: 'string' },
                    { name: 'repair_name', type: 'string' },
                    { name: 'repair_station', type: 'string' },
                    { name: 'repair_out', type: 'string' },
                    { name: 'repair_in', type: 'string' },
                    { name: 'airline_name', type: 'string' },
                    { name: 'damage_type', type: 'string' },
                    { name: 'damage_desc', type: 'string' },
                    { name: 'discarded_desc', type: 'string' },
                    { name: 'reg', type: 'string' },
                    { name: 'register', type: 'string' },
                    { name: 'awb_number', type: 'string' },
                    { name: 'mvt_status', type: 'string' },

                    { name: 'handler_name_id', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'flight_num', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                    { name: 'equipment_expiry', type: 'string' },

                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}uld-control/assets?type=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;

                    setMissingCount(data?.missingCount || 0);
                    setTotalRows({ totalUlds: data.activeCount });
                    setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '4%', filterable: false,
                },
                { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '8%', cellclassname: '', },
                { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '5%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '6%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '5%', cellclassname: '', },
                {
                    text: 'Condition Code', filtertype: 'checkedlist', filterable: true,
                    filteritems: [
                        { label: 'Serviceable', value: 'SER' },
                        { label: 'Damaged', value: 'DAM' },
                        { label: 'Discarded', value: 'DIS' }
                    ],
                    datafield: 'condition', width: '7%', cellclassname: '',
                },
                {
                    text: 'Mismatch', filtertype: 'checkedlist', datafield: 'mvt_status', width: '6%', cellclassname: '',
                    filteritems: [
                        { label: 'Yes', value: 'yes' },
                        { label: 'No', value: 'no' },
                    ],

                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            defaultHtml = "<div style='margin-left:18px;line-height: 38px;margin-top: 10px;'><span style='color: #d12828;font-weight:600;width:20px;height:20px;display: block;background: #fff;text-align: center;line-height: 17px;border: 2px solid #d12828;border-radius: 10px;font-size: 12px;'>! </span></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                {
                    text: 'Status', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'In Operation', value: '1' },
                        { label: 'On Air', value: '4' },
                        { label: 'On Loan', value: '5' },
                        { label: 'Repair', value: '2' },
                        { label: 'In Reserve', value: '3' },
                        { label: 'Missing', value: '17' },

                    ],

                    datafield: 'status', width: '7%', cellclassname: '',
                },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '5%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '5%', cellclassname: '', },
                { text: 'Handler Name', filtertype: 'textbox', datafield: 'handler_name', width: '8%', cellclassname: '', },
                { text: 'SCM', filtertype: 'textbox', datafield: 'scm', width: '4%', cellclassname: '', },
                { text: 'SCM Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'scm_date', width: '7%', cellclassname: '', },
                {
                    text: 'Asset Type', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Owned', value: 'Y' },
                        { label: 'Lease', value: 'N' },
                    ],
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.asset_type === 'Y') {
                            return '<div class="jqx-grid-cell-left-align set_dock ">Owned</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align set_dock ">Lease</div>';
                        }
                    },
                    datafield: 'asset_type', width: '6%', cellclassname: '',
                },
                // { text: 'Airline Name', filtertype: 'textbox', datafield: 'airline_name', width: '10%', cellclassname: '', },
                { text: 'Airway Bill', filtertype: 'textbox', datafield: 'awb_number', width: '7%', cellclassname: '', },
                { text: 'Equipment Expiry', filtertype: 'textbox', datafield: 'equipment_expiry', width: '10%', cellclassname: '', },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        console.log('Row Data:', rowData);
                        const dataToSend = {
                            uld_number: rowData.uld_number,
                            awb_number: rowData.awb_number,
                            type_code: rowData.type_code,
                            serial_number: rowData.serial_number,
                            owner_code: rowData.owner_code,
                            condition_code: rowData.condition_code,
                            asset_type: rowData.asset_type == 'Y' ? false : true,
                            destination: rowData.destination,
                            handler_name_id: rowData.handler_name_id,
                            flight_code: rowData.flight_code,
                            flight_num: rowData.flight_num,
                            flight_date: rowData.flight_date
                        };
                        setEditData(dataToSend);
                        setShowEdit(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    loadDetails(args.uld_number);
                }
            });
        }
    }, [gridData]);
    // START This is for irregular details open
    // useEffect(() => {
    //     const gridRef = gridRefs[activeTab].current;
    //     if (gridRef) {
    //         // Reinitialize or refresh grid data as necessary
    //         window.$(gridRef).jqxGrid('updatebounddata');
    //     }
    // }, [gridData]);
    // This is for irregular details open END
    // console.log('101', gridData);
    const loadDetails = async (uldNumber, pos) => {
        setDisLoading(true)
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    if (pos == 'top') {
                        setMissingData(innerData)
                    } else {
                        setSelectedRowData(innerData);
                        setTimeout(() => {
                            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
                        }, 30);
                    }
                    setDisLoading(false)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    const [selectedColumns, setSelectedColumns] = useState([]);
    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);

    };

    // const [downloadData, setDownloadData] = useState({
    //     condition_code: [], status: '', origin: '', type_code: '', owner_code: '',
    // })
    // const downloadModalOpen = () => {
    //     setModalOpen(true);
    //     fetchTypeCode();
    //     fetchOwnerCode();
    //     fetchCondCode();
    //     fetchDestination();
    // }
    // const exportToExcel = async () => {
    //     try {
    //         const res = await withRFSToken.post(DOWNLOADULD, { tab_name: activeTab, fields: downloadData })
    //             .then(function (res) {
    //                 if (res.data.response_code == 200) {
    //                     const fileUrl = res.data.response_data;
    //                     // Create a temporary anchor element
    //                     const link = document.createElement('a');
    //                     link.href = fileUrl;

    //                     // Extract the filename from the URL if needed
    //                     const filename = fileUrl.split('/').pop(); // Gets the last part of the URL

    //                     // Set the download attribute with the filename
    //                     link.setAttribute('download', filename);

    //                     // Append the anchor to the body (necessary for the click to work in Firefox)
    //                     document.body.appendChild(link);

    //                     // Programmatically click the anchor to trigger the download
    //                     link.click();

    //                     // Clean up by removing the anchor from the DOM
    //                     document.body.removeChild(link);
    //                     setModalOpen(false);
    //                 } else {
    //                     toast.error(res.data.response_msg)
    //                 }

    //             });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    const columnsToExport = {
        // uld_number: 'ULD Number',
        type_code: 'Type Code',
        // serial_number: 'Serial Number',
        owner_code: 'Owner Code',
        condition_code: 'Condition Code',
        status: 'Status',
        origin: 'Origin',
        destination: 'Destination',
        // scm: 'SCM',
        // scm_date: 'SCM Date',
        // asset_type: 'Asset Type',
        // handler_name: 'Handler Name',
        // airline_name: 'Airline Name',
        // Add more columns here if needed
    };
    const handleColumnChange = (columnKey) => {
        setSelectedColumns(prevSelected =>
            prevSelected.includes(columnKey)
                ? prevSelected.filter(key => key !== columnKey)
                : [...prevSelected, columnKey]
        );
    };
    // const exportToExcel = async () => {

    //     // try {
    //     //     const res = await withRFSToken.post(DOWNLOADULD, { tab_name: activeTab, fields: selectedColumns })
    //     //         .then(function (res) {
    //     //             const innerData = res.data.response_data.ulds;
    //     //             console.log("🚀 ~ .then ~ innerData:987", innerData)
    //     //             // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
    //     //             // setGridData({ Active: innerData });
    //     //             // setTotalRecords(res.data.response_data.total_ulds);
    //     //         });


    //     // } catch (error) {
    //     //     console.error('Error fetching data:', error);
    //     // }
    //     if (gridRefs[activeTab].current) {
    //         const excelData = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

    //         // const columnsToExport = ['uld_number', 'type_code']; // Add the column names you want to export
    //         // Filter the grid data to include only the specified columns
    //         // const filteredData = excelData.map(row => {
    //         //     const filteredRow = {};
    //         //     columnsToExport.forEach(col => {
    //         //         filteredRow[col] = row[col];
    //         //     });
    //         //     return filteredRow;
    //         // });
    //         // const columnsToExport = {
    //         //     uld_number: 'ULD Number',
    //         //     type_code: 'Type Code',
    //         //     serial_number: 'Serial Number',
    //         //     condition_code:'Condition Code',
    //         //     status:'Status',
    //         //     origin:'Origin',
    //         //     destination:'Destination',

    //         // };

    //         // Filter and transform the grid data to include only the specified columns with desired names
    //         const filteredData = excelData.map(row => {
    //             const filteredRow = {};
    //             // Object.keys(columnsToExport).forEach(key => {
    //             //     filteredRow[columnsToExport[key]] = row[key];
    //             // });
    //             selectedColumns.forEach(key => {
    //                 filteredRow[columnsToExport[key]] = row[key];
    //             });
    //             return filteredRow;
    //         });
    //         const worksheet = XLSX.utils.json_to_sheet(filteredData);

    //         // Create a new workbook and append the worksheet
    //         const workbook = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(workbook, worksheet, 'GridData');

    //         // Write the workbook to a file and trigger a download
    //         XLSX.writeFile(workbook, 'GridData.xlsx');
    //         setSelectedColumns([]);
    //         setModalOpen(false);
    //     }
    // };



    // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

    var settings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,

    };

    // +++++++++++++++++++++++++++++++++++ Silk Slider

    const [show, setShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState('');
    const [excelFile, setExcelFile] = useState('');

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedFile('');
    };

    // ++++++++++++++++++++++++++++++++++++ Zoom Image


    // ++++++++++++++++++++++++++++++++++++ Zoom Image

    const [missingModal, setMissingModal] = useState(false);
    const [missingInfo, setMissingInfo] = useState();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [changeFunction, setchangeFunction] = useState(null);
    const [action, setAction] = useState(null);

    const handleFieldChange = (id, fieldName, event) => {
        const { value, files } = event.target;

        setGridSelect(prevFormData =>
            prevFormData.map(stack => {
                if (stack.uid === id) {
                    const updatedStack = { ...stack, [fieldName]: value };
                    return updatedStack;
                }
                return stack;
            })
        );
    };

    const handleDropdownItemClick = (pos, action) => {
        const keysToRemove = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
        keysToRemove.forEach(key => localStorage.removeItem(key));

        // Helper function to save data to localStorage and navigate to a URL
        const saveAndNavigate = (action, data) => {
            if (action === 'expiry') {
                setShowModal(true)
            } else {
                localStorage.setItem(action, JSON.stringify(data));
                localStorage.setItem('tab', 'assets');
                const fnPageUrl = '/ULDControl/ULDFunction';  // Replace with your dynamic path if needed
                window.location.href = fnPageUrl;
            };
        }


        // Check if an action is already in operation
        const checkStatusAlreadyInOperation = (gridSelect, action) => {
            return gridSelect.some(item => item.status === action);
        };

        // Logic for handling 'details' position
        const handleDetailsAction = () => {
            if (['Repair In', 'Repair Out', 'SCM'].includes(action)) {
                const storageData = { "ULD": [selectedRowData], "Form": {} };
                saveAndNavigate(action, storageData);
            } else if (action === 'Lease Out') {
                if (selectedRowData.asset_type === 'Y') {
                    toast.error("ULDs with asset type Owned selected, this action is not possible.");
                } else {
                    const storageData = { "ULD": [selectedRowData], "Form": {} };
                    saveAndNavigate('Lease Out', storageData);
                }
            } else {
                if (action !== 'Condition') {
                    if (selectedRowData.status === action) {
                        toast.error('Status already in operation');
                    } else {
                        setAction(action);
                        setShowConfirmation(true);
                        setchangeFunction(() => changeStatus);
                    }
                } else {
                    setAction(action);
                    setShowConfirmation(true);
                    fetchDamageType();
                    setchangeFunction(() => changeStatus);
                }
            }
        };

        const missingUld = async (uld) => {
            setMissingModal(true);
            setMissingInfo(uld);
        }


        // Logic for handling 'top' position
        const handleTopAction = () => {
            const statusTest = gridSelect?.find(st => st.status === 'Missing') || null;
            console.log('rrr', statusTest);


            if (gridSelect.length === 0) {
                if (['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'expiry'].includes(action)) {
                    const storageData = { ULD: [], Form: {} };
                    saveAndNavigate(action, storageData);
                } else {
                    toast.error('Please select at least one stock to Operate');
                }
            } else {
                if (['Repair In', 'Repair Out',].includes(action)) { // 'SCM'
                    if (statusTest === null) {
                        const storageData = { ULD: gridSelect, Form: {} };
                        saveAndNavigate(action, storageData);
                    } else {
                        toast.error('You can not perform this action with missing ULD')
                    }

                } else if (['SCM',].includes(action)) {
                    const storageData = { ULD: gridSelect, Form: {} };
                    saveAndNavigate(action, storageData);
                } else if (action === 'Lease Out') {
                    if (statusTest === null) {
                        const hasOwnedAssetType = gridSelect.some(item => item.asset_type === 'Y');
                        if (hasOwnedAssetType) {
                            toast.error("ULDs with asset type Owned selected, this action is not possible.");
                        } else {
                            const storageData = { ULD: gridSelect, Form: {} };
                            saveAndNavigate(action, storageData);
                        }
                    } else {
                        toast.error('You can not perform this action with missing ULD')
                    }
                } else if (action === 'Missing') {
                    setAction(action);
                    setShowConfirmation(true);
                    fetchDamageType();
                    setchangeFunction(() => changeStatus);
                    // if (gridSelect.length > 1) {
                    //     // toast.error('You Can process only one ULD at a time')
                    //     setAction(action);
                    //     setShowConfirmation(true);
                    //     fetchDamageType();
                    //     setchangeFunction(() => changeStatus);
                    // } else {
                    //     if (gridSelect[0].status == 'Missing') {
                    //         toast.error('ULD is already Missing')
                    //     } else {
                    //         missingUld(gridSelect[0].uld_number);
                    //         loadDetails(gridSelect[0].uld_number, 'top');
                    //     }
                    // }
                } else {
                    if (statusTest === null) {
                        if (action !== 'Condition') {
                            if (checkStatusAlreadyInOperation(gridSelect, action)) {
                                toast.error(`Status already ${action}`);
                            } else {
                                setAction(action);
                                setShowConfirmation(true);
                                setchangeFunction(() => changeStatus);
                            }
                        } else {
                            setAction(action);
                            setShowConfirmation(true);
                            fetchDamageType();
                            setchangeFunction(() => changeStatus);
                        }
                    } else {
                        toast.error('You can not perform this action with missing ULD')
                    }
                }
            }
        };

        // Main conditional logic based on the position (pos)
        if (pos === 'details') {
            handleDetailsAction();
        } else if (pos === 'top') {
            handleTopAction();
        }
    };


    const missingModalClose = () => {
        setMissingModal(false);
    }
    const reportMissing = async () => {
        setIsSaving(true);
        try {
            const res = await withRFSToken.post(RECMISSING, { uld_id: [missingData.uld_id] })
            // .then(function (res) {
            if (res.data.response_code == 200) {
                toast.success('ULD Reported as Missing');
                setMissingModal(false);
                setIsLoading(true);
                setIsSaving(false);
                if (activeTab == 'Active') {
                    setTimeout(() => {
                        setIsLoading(false);
                        setGridData({ Active: {} });
                    }, 1);
                } else {
                    setTimeout(() => {
                        setIsLoading(false);
                        setGridData({ Archived: {} });
                    }, 1);
                }
                setGridSelect([]);
            } else { toast.error(res.data.response_msg); setIsSaving(false); }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const movementHistoryClick = () => {
        try {
            // Check if selectedRowData is defined
            if (!selectedRowData) {
                throw new Error('Selected row data is not available.');
            }

            localStorage.removeItem('MHistory');
            const storageData = {
                ULD: selectedRowData,  // ULD Details section
                Form: {}  // Empty form section
            };
            localStorage.setItem('MHistory', JSON.stringify(storageData));
            localStorage.setItem('tab', 'assets');
            window.location.href = '/ULDControl/MovementHistory'
        } catch (error) {
            // Log the error for debugging purposes
            console.error('Error during navigation:', error.message);
            alert('An error occurred: ' + error.message); // Optional user alert
        }
    }
    const handleCancelChange = () => {
        // setGridSelect([]);
        setShowConfirmation(false);
        setAction(null);
        setAssetType('');
    };
    const handleConfirmChange = async (actionType) => {
        // deleteRow(gridSelect);
        if (actionType == 'In Operation') {
            const uldNumbers = selectedRowData ? selectedRowData.uld_number : gridSelect.map(item => item.uld_number);
            try {
                const res = await withRFSToken.post(UPDATESTATUS, { uld_codes: uldNumbers, status: 1 });
                if (res.data.response_code == 200) {
                    toast.success('Status changed to In Operation');
                    fetchDataGrid();
                    // unselect Grid
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    setGridSelect([]);
                    //   Grid unselect and blank variable End
                    changeFunction(gridSelect)
                    setShowConfirmation(false);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else if (actionType == 'Asset Type') {
            const uldNumbers = selectedRowData ? selectedRowData.uld_number : gridSelect.map(item => item.uld_id);
            CallApi({
                endPoint: 'uld-action/update-asset-type',
                payload: { uld_ids: uldNumbers, asset_type: assetType },
                onSuccess: (data) => {
                    // console.log('sendData', data);
                    const resCode = data.data.response_code;
                    if (resCode === 200) {
                        toast.success(data.data.response_msg);
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        }, 1);
                        setShowConfirmation(false);
                    } else {
                        toast.error(data.data.response_msg);
                    }
                    setIsLoading(false)
                },
                onError: (msg) => toast.error(msg)
            });
        } else if (actionType == 'In Reserve') {
            const uldNumbers = selectedRowData ? selectedRowData.uld_number : gridSelect.map(item => item.uld_number);
            try {
                const res = await withRFSToken.post(UPDATESTATUS, { uld_codes: uldNumbers, status: 3 });
                if (res.data.response_code == 200) {
                    toast.success('Status changed to In Reserve');
                    fetchDataGrid();
                    setShowConfirmation(false);
                    // unselect Grid
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    setGridSelect([]);
                    //   Grid unselect and blank variable End
                    changeFunction(gridSelect)

                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else if (actionType == 'Missing') {
            // const uldNumbers = selectedRowData ? selectedRowData.uld_number : gridSelect.map(item => item.uld_number);
            const uldNumbers = gridSelect.map(item => item.uld_id);
            try {
                // const res = await withRFSToken.post(UPDATESTATUS, { uld_codes: uldNumbers, status: 3 });
                const res = await withRFSToken.post(RECMISSING, { uld_id: uldNumbers, missing_datetime: missingDateTime })
                if (res.data.response_code == 200) {
                    toast.success('ULD Reported as Missing');
                    setShowConfirmation(false);
                    setIsLoading(true);
                    setIsSaving(false);
                    if (activeTab == 'Active') {
                        setTimeout(() => {
                            setIsLoading(false);
                            setGridData({ Active: {} });
                        }, 1);
                    } else {
                        setTimeout(() => {
                            setIsLoading(false);
                            setGridData({ Archived: {} });
                        }, 1);
                    }
                    setGridSelect([]);

                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else if (actionType == 'Condition') {
            // selectedRowData ? selectedRowData.uld_number : gridSelect.map(item => item.uld_number)
            const conditionType = conditionChange && conditionChange == 'Serviceable' ? 'SER' : (conditionChange == 'Damage' ? 'DAM' : 'DIS')
            if (conditionChange == 'Serviceable') {
                const uldNumbers = gridSelect && gridSelect.map(item => ({ code: item.uld_number }));
                try {
                    const res = await withRFSToken.post(UPDATECONDITION, { uld_codes: uldNumbers, condition_type: conditionType });
                    if (res.data.response_code == 200) {
                        toast.success('Condition Updated');
                        fetchDataGrid();
                        setShowConfirmation(false);
                        // unselect Grid
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        //   Grid unselect and blank variable End
                        changeFunction(gridSelect)

                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            } else {
                const uldDam = gridSelect.map(item => ({ code: item.uld_number, damage_type: item.damage_type, desc: item.desc, files: item.base64Files }));
                // console.log("🚀 ~ handleConfirmChange ~ uldDam:", uldDam)
                try {
                    const res = await withRFSToken.post(UPDATECONDITION, { uld_codes: uldDam, condition_type: conditionType });
                    if (res.data.response_code == 200) {
                        toast.success('Condition Updated');
                        fetchDataGrid();
                        setShowConfirmation(false);
                        // unselect Grid
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        //   Grid unselect and blank variable End
                        changeFunction(gridSelect);
                        setGridSelect([]);
                        setFiles([]);
                        setBase64Files([]);
                        if (selectedRowData) {
                            loadDetails(selectedRowData.uld_number)
                        }


                    } else { toast.error(res.data.response_msg) }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }

        }
        setSelectedRowData(null)
    };

    //   +++++++++ single select station +++++++
    let [selected, setSelected] = useState([]);
    if (selected.length > 1) {
        selected = selected.slice(1);
    }
    const options = [
        { id: '1', label: 'option1', value: 'option1' },
        { id: '1', label: 'option2', value: 'option2' },
        { id: '1', label: 'option3', value: 'option3' },
        { id: '1', label: 'option4', value: 'option4' },
    ];
    const handleSelectChange = (selected) => {
        setSelected(selected);
    };
    //   +++++++++ single select station +++++++
    const handleRemove = (indexToRemove) => {
        console.log("🚀 ~ handleRemove ~ indexToRemove:", indexToRemove)
        // const idToRemove = gridSelect[indexToRemove];
        // const selectedRowBoundIndex = idToRemove.boundindex;
        // window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // // setGridSelect(prevGridSelect => prevGridSelect.filter((id) => id.uid !== indexToRemove));
        // const newGridSelect = [...gridSelect.slice(0, indexToRemove), ...gridSelect.slice(indexToRemove + 1)];
        // setGridSelect(newGridSelect);
        setGridSelect(prev => prev.filter(row => row.uld_number !== indexToRemove));
        const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        rows.forEach((element, index) => {
            if (element.uld_number == indexToRemove) {
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', index);
            }
        });

    };

    const changeStatus = async (selectedIds) => {
        // console.log("🚀 ~ deleteSelectedRows ~ selectedIds:", selectedIds)

        //console.log("🚀 ~ changeStatus ~ uniqueIds:", uniqueIds)
        // console.log("🚀 ~ changeStatus ~ uniqueIds:", uniqueIds)
        // try {
        //   const res = await withToken.post(TRASH_ROW_IDS, {booking_ids: uniqueIds});
        //   console.log("responsehg==>", res);
        //   window.$(gridRef.current).jqxGrid('unselectrow', selectedIds);
        //   const updategrid = window.$(gridRef.current).jqxGrid();
        //   // setupGrid();
        //   reloadGrid();
        //   setGridSelect([]);
        //   window.$(gridRef.current).jqxGrid('clearselection');

        //   // setTimeout(() => {
        //   //    window.location.replace('/')  
        //   // },1000);

        // } catch (error) {
        //   console.error('Error sending request:', error);
        // }
    };

    const conditionModalClose = () => {
        setShowConfirmation(false);
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => ({
                ...item,
                files: [],
                base64Files: []
            }))
        );
        setFiles([])
        setBase64Files([]);
    }

    const [conditionChange, setConditionChange] = useState('Serviceable');
    const [actArcModal, setActArcModal] = useState(false);
    const [assetType, setAssetType] = useState('');

    const handleConditionRadioChange = (e) => {

        setConditionChange(e.target.value);
    };

    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? 'R' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.uld_id)
        try {
            const res = await withRFSToken.post(MOVETOACTARC, { uld_numbers: uldNumbers, action: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        fetchDataGrid()
                        // if (activeTab == 'Active') {
                        //     toast.success('ULD Data moved to Arhive');
                        //     fetchDataGrid()
                        // } else {
                        //     toast.success('ULD Data moved to Active');
                        //     fetchDataGridR()
                        // }
                        setActArcModal(false)
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    // upload Section
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }
    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    // const handleFileChange = (e) => {
    //     const selectedFiles = Array.from(e.target.files);
    //     const filesWithBase64 = [];
    //     selectedFiles.forEach((file) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             filesWithBase64.push({ file, base64: reader.result });
    //             if (filesWithBase64.length === selectedFiles.length) {
    //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

    //             }
    //         };
    //         reader.readAsDataURL(file);
    //     });
    // }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleDetailsClick = async (history) => {

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }
        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id, group_id: history.group_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        // localStorage.removeItem('MHistory');
        // localStorage.removeItem('MHDetails');
        // const storageData = {
        //     ULD: selectedRowData,  // ULD Details section
        //     Form: {}  // Empty form section
        // };
        // localStorage.setItem('MHistory', JSON.stringify(storageData));
        // const storageDataDetails = {
        //     ULD: history,  // ULD Details section
        //     tab: 'All'  // Empty form section
        // };
        // localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
        // localStorage.setItem('tab', 'assets');
        // let detailsPageUrl;
        // const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
        // if (detailsType) {

        //     detailsPageUrl = '/ULDControl/MovementHistorydetais';
        //     window.location.href = detailsPageUrl;
        // } else {
        //     console.log('No valid details type found');
        // }

    };
    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        // gridSelect.forEach(item => {
        //     const selectedRowBoundIndex = item.boundindex;
        //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // });
        // setGridSelect([]);
    };

    const goRecovery = (src) => {
        if (src == 'missing') {
            localStorage.setItem('Rtab', 'missing');
            window.location.href = '/Recovery'
        } else if (src == 'inactive') {
            localStorage.setItem('Rtab', 'inactive');
            window.location.href = '/Recovery'
        }
    }
    //  const { handleDropdownItemClick } = useDropdownActions({
    //     selectedRowData,
    //     gridSelect,
    //     setAction,
    //     setShowConfirmation,
    //     setchangeFunction,
    //     changeStatus,
    //     fetchDamageType,
    //     tabName: 'assets'
    // });
const handlexcelChange = (event) => {
        setExcelFile(event.target.files[0]);

        const input = event.target;
        console.log("🚀 ~ handleFileChange ~ input:", input.files)
        if (input.files && input.files[0]) {
            const file = input.files[0];
            setFileName(file.name);
            setExcelFile(file);
        }
    };
    const handleUpload = async () => {
        if (!excelFile) {
            toast.error("Please select a file first!");
            return;
        }

        if (excelFile) {

            try {
                const formData = new FormData();
                formData.append("file", excelFile);
                // console.log("🚀 ~ handleUpload ~ selectedFile:", formData)
                // console.log("🚀 ~ handleUpload ~ selectedFile:", selectedFile)

                const res = await withRFSToken.post(
                    '/uld-action/update-equipment-expiry',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                // const res = await withRFSToken.post('shipment/import-shipment-record', formData,{
                //     headers: {
                //         'Content-Type': 'multipart/form-data'
                //         }
                // });
                // .then(function (res) {
                if (res.data.response_code == 200) {
                    toast.success(res.data.response_msg);
                    setGridSelect([]);
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    setFileName('');
                    setShowModal(false);
                } else { toast.error(res.data.response_msg) }
                // });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    const handleDownloadClick = () => {
        const a = document.createElement('a');
        a.href = XLSFILE;
        a.download = 'ULD_Equipment_Expiry_Date.xls'; // Name for the downloaded file
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    return (
        <>
            {/* {console.log('kol', gridSelect)}{console.log('new ids', checkUlds)} */}
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {showEdit && <EditUld edit_data={editData} reloadEdit={fetchDataGrid} onClose={handleCloseEditModal} />}
            {downloadOpen && <DownloadGrid download_sec={activeTab} onClose={closeDownloadModal} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                            <FontAwesomeIcon icon={faPlus} /> Add ULD <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                            {/* <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Operation', 'assets')}>In Operation</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Asset Type', 'assets')}>Asset Type</Dropdown.Item>
                            {/* <Dropdown.Item onClick={() => handleDropdownItemClick('On Air')}>On Air</Dropdown.Item> */}
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In', 'assets')}>Repair In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair Out', 'assets')}>Repair Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Reserve', 'assets')}>In Reserve</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Lease Out', 'assets')}>Lease Out</Dropdown.Item>
                            {/* <Dropdown.Item onClick={() => handleDropdownItemClick('Lease In')}>Lease In</Dropdown.Item> */}
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'SCM', 'assets')}>SCM</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Missing', 'assets')}>Missing</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'expiry', 'assets')}>Update Equipment Expiry</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <button className="condition" variant="link" onClick={() => handleDropdownItemClick('top', 'Condition', 'assets')}>
                        <span> <FontAwesomeIcon icon={faCircleCheck} /> Condition</span>
                    </button>
                    <span className="selected">
                        Selected ULD <Badge>{gridSelect.length}</Badge>
                    </span>
                    <button className="selected" variant="link" onClick={() => goRecovery('missing')}>
                        Missing ULD <Badge className='bg_missing' >{missingCount}</Badge>
                    </button>
                    <button className="selected" variant="link" onClick={() => goRecovery('inactive')}>
                        Inactive ULD <Badge className='bg_inactive'>{inactiveCount}</Badge>
                    </button>
                </div>
            </div>

            <div className='ulddown'>
                {activeTab == 'Active' ? (
                    <>
                        <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>
                        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                    </>
                ) : (
                    <>
                        <button onClick={handleMoveToActArc}> <img title='' src={Activ} /> Active </button>
                        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                    </>
                )
                }

            </div>

            <div className="maindiv">
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp; <span>{selectedRowData.status}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Operation')}>In Operation</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair In')}>Repair In</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair Out')}>Repair Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Reserve')}>In Reserve</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Lease Out')}>Lease Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'SCM')}>SCM</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='d-flex justify-content-between rabord'>
                            <div className='firstbrd'>
                                <p>Origin</p>
                                <span>{selectedRowData.origin}</span>
                            </div>
                            <div className='middlebrd'>
                                <p>{selectedRowData.flight_date}</p>
                                <p><img src={Cargoplane} /></p>
                                <p>{selectedRowData.flight_number}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>Destination</p>
                                <span>{selectedRowData.destination}</span>
                            </div>
                        </div>
                        <div className='movment_history'>
                            <h3>Movement History</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                    <li key={index}>
                                        <span className='movem'>{history.operation_type}</span> <span className='mvdate'>{history.operation_date}</span>
                                        <Link to="#" onClick={() => handleDetailsClick(history)}>Details</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"uld"}
                            attachable_id={selectedRowData.uld_number}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
                        />
                        <ActivityComments
                            commentable_type={"uld"}
                            commentable_id={selectedRowData.uld_number}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={loadDetails}
                        />
                        {/* <div className='mt-4'>
                            
                            
                            <div className='d-flex racomment'>
                                <div className='coment_img'><img src={Cuser} /></div>
                                <div>
                                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> </div>
                                    <p>I have no reply, so i will take this ticket to next week</p>
                                </div>
                            </div>

                            <div className='d-flex racomment'>
                                <div className='coment_img'><img src={Cuser} /></div>
                                <div>
                                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> <Button variant="link"><FontAwesomeIcon icon={faLink} /></Button> </div>
                                    <p>I have no reply, so i will take this ticket to next week</p>
                                </div>
                            </div>

                            <div className='d-flex racomment'>
                                <div className='coment_img'><img src={Cuser} /></div>
                                <div>
                                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> <Button variant="link"><FontAwesomeIcon icon={faLink} /></Button> </div>
                                    <p>I have no reply, so i will take this ticket to next week</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                )}
            </div>

            <Modal show={showModalUpload} onHide={() => setShowModalUpload(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className='type_work'>

                        <div className='ra_condition'>
                            <div
                                className='dropfile'
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <h3>Drag and drop files here</h3>
                                <p>Or</p>
                                <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                <span>Maximum file size 4 MB</span>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    multiple
                                />
                            </div>
                            <div className='uploadbox'>
                                {files.map((file, index) => (
                                    <div key={index} className='uploadfil'>
                                        {file.base64.includes('image') ? (
                                            <img
                                                src={file.base64}
                                                alt="Preview"
                                                style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                            />
                                        ) : (
                                            <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                        )}
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={imageUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal className='addfrom in_oparation' show={showConfirmation} onHide={() => conditionModalClose()} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{action == 'Missing' ? 'Report ULD Missing' : action == 'Asset Type' ? 'Change ' + action : action}</Modal.Title>
                    <p>{action === 'Condition'
                        ? 'Select Condition by selecting the option.'
                        : action == 'Missing'
                            ? "Do you want to  report selected ULD's as " + action + '?'
                            : "Do you want to change selected ULD's to " + action + '?'}
                    </p>
                    {/* {['Repair', 'Lease Out', 'Condition'].includes(action) ? action : null} */}
                </Modal.Header>
                <Modal.Body>
                    {action == 'Asset Type' &&
                        <>
                            <Form.Group controlId="dropdown" className='mb-3 ck_condition'>
                                <Form.Check
                                    type='radio'
                                    label='Owned'
                                    name='assetType'
                                    id='own'
                                    value='Y'
                                    checked={assetType === 'Y'}
                                    onChange={() => setAssetType('Y')}
                                />
                                <Form.Check
                                    type='radio'
                                    label='Lease'
                                    name='assetType'
                                    id='lease'
                                    value='N'
                                    checked={assetType === 'N'}
                                    onChange={() => setAssetType('N')}
                                />
                            </Form.Group>
                        </>
                    }
                    {action == 'Condition' ?
                        (
                            <>
                                <Form.Group controlId="dropdown" className='mb-3 ck_condition'>
                                    <Form.Check
                                        label="Serviceable"
                                        name="condition_type"
                                        type='radio'
                                        id='Serviceable'
                                        value="Serviceable"
                                        checked={conditionChange === 'Serviceable'}
                                        onChange={handleConditionRadioChange}
                                    />
                                    <Form.Check
                                        label="Damaged"
                                        name="condition_type"
                                        type='radio'
                                        id='Damage'
                                        value="Damage"
                                        checked={conditionChange === 'Damage'}
                                        onChange={handleConditionRadioChange}
                                    />
                                    <Form.Check
                                        label="Discarded"
                                        name="condition_type"
                                        type='radio'
                                        id='Discarded'
                                        value="Discarded"
                                        checked={conditionChange === 'Discarded'}
                                        onChange={handleConditionRadioChange}
                                    />
                                </Form.Group>

                                <div className={conditionChange == 'Serviceable' ? 'd-flex flex-row flex-wrap bd-highlight inop serv_width' : 'd-flex flex-column bd-highlight inop '}>
                                    {gridSelect && gridSelect.map((num, index) => (
                                        <>
                                            {conditionChange == 'Serviceable' ? (
                                                <div key={index} className='inbox d-flex justify-content-between align-items-center'>
                                                    <span>{num.uld_number}</span>

                                                    <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                                </div>
                                            ) : (conditionChange == 'Damage' ? (
                                                <div key={index} className='inbox d-flex justify-content-start align-items-center damage_w'>
                                                    <div><span>{num.uld_number}</span></div>
                                                    <div>
                                                        {/* <Form.Select name='damage_type' id={num.uid} onChange={(event) => handleFieldChange(num.uid, 'damage_type', event)}>
                                                            <option>Damag Type</option>
                                                            {damageType &&
                                                                Object.entries(damageType).map((option, index) =>
                                                                    <option key={index} value={option[0]}>{option[0]} - {option[1]}</option>
                                                                )
                                                            }
                                                        </Form.Select> */}
                                                        <Select
                                                            options={damageType}
                                                            onChange={(selected) => {
                                                                const updatedData = gridSelect.map(item => {
                                                                    if (item.uid === num.uid) {
                                                                        return { ...item, damage_type: selected.value };
                                                                    }
                                                                    return item;
                                                                });
                                                                setGridSelect(updatedData);
                                                            }}
                                                            placeholder="Damage Type"
                                                            className='autoslct'
                                                            name="damage_type"
                                                        // value={damageType.find(option => option.value === num.damage_type)}
                                                        />
                                                    </div>
                                                    <div>
                                                        <Form.Control type="text" placeholder="Damage Description" name='desc' onChange={(event) => handleFieldChange(num.uid, 'desc', event)} />
                                                    </div>
                                                    <div>
                                                        <Button variant="outline-primary" className='upfile' onClick={() => imageModalUpload(num.uid)}>Upload file {num.files && num.files.length > 0 ? num.files.length : ''}</Button>
                                                    </div>
                                                    <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                                </div>
                                            ) : (
                                                <div key={index} className='inbox d-flex justify-content-start align-items-center damage_w'>
                                                    <div><span>{num.uld_number}</span></div>
                                                    <div>
                                                        <Form.Control type="email" placeholder="Discarded Description" className='dis_des' name='desc' onChange={(event) => handleFieldChange(num.uid, 'desc', event)} />
                                                    </div>
                                                    <div>
                                                        <Button variant="outline-primary" className='upfile' onClick={() => imageModalUpload(num.uid)}>Upload file {num.files && num.files.length > 0 ? num.files.length : ''}</Button>
                                                    </div>
                                                    <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                                </div>
                                            ))}

                                        </>
                                    ))}
                                </div>

                            </>
                        ) : (action == 'Missing' ?
                            <>
                                <div className='inop' style={{ marginBottom: '20px' }}>
                                    <Form.Label style={{ marginRight: '20px', width: 'auto' }}>Missing Reported</Form.Label>
                                    <Form.Control
                                        className='d-inline-block'
                                        style={{ width: `25%` }}
                                        type="datetime-local"
                                        name='missing_datetime'
                                        onChange={(e) => setMissingDateTime(e.target.value)}
                                    // value={section.flight_date}
                                    />
                                </div>
                                <div className='d-flex flex-wrap inop opara_w'>
                                    {selectedRowData ? (
                                        <div className='inbox'><span>{selectedRowData.uld_number}</span></div>
                                    ) : (
                                        <>
                                            {gridSelect && gridSelect.map((num, index) => (

                                                <div key={index} className='inbox'>
                                                    <span>{num.uld_number}</span>
                                                    <img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} />
                                                </div>
                                            ))}
                                        </>
                                    )}

                                    {/* {selectedRowData && <div className='inbox'><span>{selectedRowData.uld_number}</span></div>} */}
                                </div>

                            </>
                            :
                            <div className='d-flex flex-wrap inop opara_w'>
                                {selectedRowData ? (
                                    <div className='inbox'><span>{selectedRowData.uld_number}</span></div>
                                ) : (
                                    <>{gridSelect && gridSelect.map((num, index) => (

                                        <div key={index} className='inbox'>
                                            <span>{num.uld_number}</span>
                                            <img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} />
                                        </div>
                                    ))}
                                    </>
                                )}
                            </div>
                        )}

                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="secondary" onClick={handleCancelChange}> */}
                    {/* {['Repair', 'Lease In', 'Lease Out', 'Condition'].includes(action) ? 'Cancel' : 'No'} */}
                    {/* </Button> */}
                    {action == 'Asset Type' ?
                        <div className="d-flex w-50 mx-auto are_bottom">
                            <Button variant="secondary" onClick={handleCancelChange}>Cancel</Button>
                            <Button variant="primary" onClick={() => handleConfirmChange(action)}>Update</Button>
                        </div>
                        :
                        <Button variant="primary" onClick={() => handleConfirmChange(action)}>
                            {['Repair', 'Lease Out', 'Condition', 'SCM'].includes(action) ? 'Update Status ' + action : (['Missing'].includes(action) ? 'Report Missing' : 'Update Status')}
                        </Button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Selected {gridSelect.length > 1 ? "ULD's" : 'ULD'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
                    <p>Are you sure you want to move {gridSelect.length > 1 ? "ULD's" : 'ULD'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confirmMoveToActArc}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={missingModal} onHide={!isSaving ? missingModalClose : null} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>ULD Missing</h3>
                    <p>Please review the information below and select the <br /> Report ULD Missing button to report the ULD as missing. </p>
                    <div className='missing_info'>
                        <h4>ULD Information</h4>
                        <p>Overview of ULD Specifications</p>
                        <ul>
                            <li>
                                <span>ULD Number</span> <span>:   {missingData?.uld_number}</span>
                            </li>
                            <li>
                                <span>Condition</span> <span>:   {
                                    missingData?.condition_code == 'SER' ? 'Serviceable'
                                        : (missingData?.condition_code == 'DAM' ? 'Damage'
                                            : 'Discarded'
                                        )
                                }</span>
                            </li>
                            <li>
                                <span>Last Seen Location</span> <span>:  {missingData?.last_seen_location}</span>
                            </li>
                            <li>
                                <span>Last Seen Date</span> <span>:  {missingData?.movement_history[0]?.operation_date}</span>
                            </li>
                        </ul>
                    </div>
                    <div className='missing_info mb-0'>
                        <h4>Movement Information</h4>
                        <p>Last Know ULD Movement Information</p>

                        <ul>
                            <li>
                                <span>Last Movement Type</span> <span>:    {missingData?.movement_history[0]?.operation_type}</span>
                            </li>
                            {['UCM In', 'UCM Out'].includes(missingData?.movement_history[0]?.operation_type) ?
                                <>
                                    <li><span>Truck/Flight </span> <span>: {missingData?.movement_history[0]?.flight_or_truck === 'F' ? 'Flight' : 'Truck'}</span></li>
                                    <li><span>Flight Number </span> <span>: {missingData?.movement_history[0]?.flight_number}</span></li>
                                    <li><span>Flight Date </span> <span>: {missingData?.movement_history[0]?.flight_date}</span></li>
                                    <li><span>Origin </span> <span> : {missingData?.movement_history[0]?.origin}</span></li>
                                    <li><span>Origin Handler Name</span> <span>: {missingData?.movement_history[0]?.origin_handler}</span></li>
                                    <li><span>Destination</span> <span>: {missingData?.movement_history[0]?.destination}</span></li>
                                    <li><span>Destination Handler Name</span> <span>: {missingData?.movement_history[0]?.destination_handler}</span></li>
                                    <li><span>Registration Number</span> <span>: {missingData?.movement_history[0]?.flight_reg_number}</span></li>
                                </>
                                : (missingData?.movement_history[0]?.operation_type === 'LUC Out' ?
                                    <>
                                        <li><span>Transfer Date</span> <span>: {missingData?.movement_history[0]?.operation_date}</span></li>
                                        <li><span>Control Receipt Number</span> <span>: {missingData?.movement_history[0]?.control_receipt_no}</span></li>
                                        <li><span>Transfer Point</span> <span>: {missingData?.movement_history[0]?.transfer_point}</span></li>
                                        <li><span>Transferred By</span> <span>: {missingData?.movement_history[0]?.transferred_by}</span></li>
                                        <li><span>Final Destination</span> <span>: {missingData?.movement_history[0]?.luc_final_dest}</span></li>
                                        <li><span>Received By</span> <span>: {missingData?.movement_history[0]?.received_by}</span></li>
                                    </>
                                    : (missingData?.movement_history[0]?.operation_type === 'LUC In' ?
                                        <>
                                            <li><span>Return Date</span> <span>: {missingData?.movement_history[0]?.operation_date}</span></li>
                                            <li><span>Control Receipt Number</span> <span>: {missingData?.movement_history[0]?.control_receipt_no}</span></li>
                                            <li><span>Return To</span> <span>: {missingData?.movement_history[0]?.return_to}</span></li>
                                            <li><span>Transfer Point</span> <span>: {missingData?.movement_history[0]?.transfer_point}</span></li>
                                            <li><span>Returned By</span> <span>: {missingData?.movement_history[0]?.returned_by}</span></li>
                                        </>
                                        : (['Station Transfer', 'Transfer Request'].includes(missingData?.movement_history[0]?.operation_type) ?
                                            <>
                                                <li><span>Transfer Date</span> <span>: {missingData?.movement_history[0]?.operation_date}</span></li>
                                                <li><span>Control Receipt Number</span> <span>: {missingData?.movement_history[0]?.control_receipt_no}</span></li>
                                                <li><span>Transfer Point</span> <span>: {missingData?.movement_history[0]?.transfer_point}</span></li>
                                                <li><span>Transferred By</span> <span>: {missingData?.movement_history[0]?.transferred_by}</span></li>
                                                <li><span>Final Destination</span> <span>: {missingData?.movement_history[0]?.luc_final_dest}</span></li>
                                                <li><span>Received By</span> <span>: {missingData?.movement_history[0]?.received_by}</span></li>
                                            </>
                                            : (['Repair In', 'Repair Out'].includes(missingData?.movement_history[0]?.operation_type) ?
                                                <>
                                                    <li><span>Repair Name</span> <span>: {missingData?.movement_history[0]?.repair_name}</span></li>
                                                    <li><span>Repair Station</span> <span>: {missingData?.movement_history[0]?.repair_station}</span></li>
                                                    <li><span>Repair In</span> <span>: {missingData?.movement_history[0]?.operation_date}</span></li>
                                                </>
                                                : (missingData?.movement_history[0]?.operation_type === 'Lease Out' ?
                                                    <>
                                                        <li><span>Station Out</span> <span>: {missingData?.movement_history[0]?.destination}</span></li>
                                                    </>
                                                    : (missingData?.movement_history[0]?.operation_type === 'SCM' ?
                                                        <>
                                                            <li><span>Date of Check</span> <span>: {missingData?.movement_history[0]?.operation_date}</span></li>
                                                            <li><span>Destination</span> <span>: {missingData?.movement_history[0]?.destination}</span></li>
                                                            <li><span>Destination Handler Name</span> <span>: {missingData?.movement_history[0]?.destination_handler}</span></li>
                                                        </>
                                                        : ''
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            }
                            {/* <li>
                                <span>Flight Number</span> <span>:   {selectedRowData?.movement_history[0]?.flight_number}</span>
                            </li>
                            <li>
                                <span>Flight Date</span> <span>:   {selectedRowData?.movement_history[0]?.flight_date}</span>
                            </li>
                            <li>
                                <span>Origin</span> <span>:  {selectedRowData?.movement_history[0]?.origin}</span>
                            </li>
                            <li>
                                <span>Origin Handler Name</span> <span>: {selectedRowData?.movement_history[0]?.origin_handler}</span>
                            </li>
                            <li>
                                <span>Destination</span> <span>: {selectedRowData?.movement_history[0]?.destination}</span>
                            </li>
                            <li>
                                <span>Destination Handler Name</span> <span>:  {selectedRowData?.movement_history[0]?.destination_handler}</span>
                            </li>
                            <li>
                                <span>Registration Number</span> <span>:  {selectedRowData?.movement_history[0]?.flight_reg_number}</span>
                            </li> */}
                        </ul>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={reportMissing} disabled={isSaving} className='position-relative'>
                        {isSaving ? <>Report ULD Missing<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Report ULD Missing'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>

                    <h3>Import Excel</h3>
                    <p>Upload the filled in template to add ULDs.</p>
                    <div className='asset_midle'>

                        <div className='upload_tmpl'>
                            <button onClick={handleDownloadClick}>
                                <FontAwesomeIcon icon={faDownload} />
                                <span>Download Template (Excel) </span>
                            </button>
                            <div className="form-group inputDnD">
                                <FontAwesomeIcon icon={faUpload} />
                                <input
                                    type="file" className="form-control-file "
                                    id="inputFile"
                                    // accept=".xlsx, .xls, .csv"
                                    onChange={handlexcelChange}
                                    data-title="Upload your file (Excel)" />

                                {/* {fileData && (
                                                                        <div>
                                                                            <h4>File Data:</h4>
                                                                            <pre>{fileData}</pre>
                                                                        </div>
                                                                    )} */}
                            </div>
                        </div>
                        {/* {console.log('fileName', fileName)} */}
                        {fileName && (
                            <div className='rafilname'>
                                <p>File Name: {fileName}</p>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Assets